import { render } from "./PermissionConfirmModal.vue?vue&type=template&id=6b3c9bf1"
import script from "./PermissionConfirmModal.vue?vue&type=script&lang=js"
export * from "./PermissionConfirmModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__